var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("label",[_c('info-icon',{class:{'f-topic-official-more-label': true,
                'has-padding': _vm.hasPadding},attrs:{"info":_vm.info}})]),_vm._t("annex"),_vm._t("options"),_vm._t("editor"),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }